"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSkeletonWrapper = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const StyledSkeletonWrapper = exports.StyledSkeletonWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledSkeletonWrapper",
  class: "s15lj2mg",
  vars: {
    "s15lj2mg-0": [props => props.width]
  }
});